import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex justify-between w-full border-l-[10px] border-primary-400 mt-8 mb-8 text-2xl text-left font-extrabold pt-2 pb-2 pl-4" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, "Mis Blocks", -1)
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "flex flex-wrap mb-" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SearchBox = _resolveComponent("SearchBox")!
  const _component_BlockCard = _resolveComponent("BlockCard")!
  const _component_NewBlockCard = _resolveComponent("NewBlockCard")!
  const _component_BlockView = _resolveComponent("BlockView")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode(_component_SearchBox, {
        onSearchCommunity: _ctx.handleSearch,
        width: "w-72"
      }, null, 8, ["onSearchCommunity"])
    ]),
    (!_ctx.showBlockView)
      ? (_openBlock(), _createElementBlock("section", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.blocksCommunity, (block) => {
              return (_openBlock(), _createBlock(_component_BlockCard, {
                key: block.id,
                blocksCommunity: block,
                onDeleteCommunity: _ctx.deleteBlock,
                onShowDetails: ($event: any) => (_ctx.showDetails(block.id))
              }, null, 8, ["blocksCommunity", "onDeleteCommunity", "onShowDetails"]))
            }), 128)),
            _createVNode(_component_NewBlockCard, {
              class: "cursor-pointer mt-5",
              communityId: _ctx.communityId,
              onReload: _ctx.reload
            }, null, 8, ["communityId", "onReload"])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showBlockView)
      ? (_openBlock(), _createBlock(_component_BlockView, {
          key: 1,
          visible: _ctx.showBlockView,
          "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.showBlockView) = $event)),
          blockId: _ctx.blockId,
          communityId: _ctx.communityId
        }, null, 8, ["visible", "blockId", "communityId"]))
      : _createCommentVNode("", true)
  ]))
}